var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"primary1--text headline font-weight-bold"},[_vm._v("\n        ANEXOS\n      ")])])],1),_c('TabelaAnexos',{attrs:{"role":'admin_brasil'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }